<div class="button-container">
	<button
      class="btn btn-sm cv-btn-blue"
      [disabled]="saving || !isDirty"
      (click)="onSave()"
    >
      <div *ngIf="saving" class="loading-wrapper">
        <i class="fas fa-spinner"></i>
      </div>
      Save
    </button>
</div>
